import PublicLayout from "../../containers/PublicLayout"
import PaymentSteps from "../../components/Payment/PaymentStepsForms"

const Payment = () => {
  return (
    <PublicLayout>
      <PaymentSteps />
    </PublicLayout>
  )
}

export default Payment
